import { render, staticRenderFns } from "./HandleSection.vue?vue&type=template&id=bddd77b8&scoped=true&"
import script from "./HandleSection.vue?vue&type=script&lang=ts&"
export * from "./HandleSection.vue?vue&type=script&lang=ts&"
import style0 from "./HandleSection.vue?vue&type=style&index=0&id=bddd77b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddd77b8",
  null
  
)

export default component.exports